	function getUrlVars() {
	    var vars = [],
	        hash;
	    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
	    for (var i = 0; i < hashes.length; i++) {
	        hash = hashes[i].split('=');
	        vars.push(hash[0]);
	        vars[hash[0]] = hash[1];
	    }
	    return vars;
	}

	var ms = getUrlVars()["ms"];
	var mt = getUrlVars()["mt"];
	var s_cid = getUrlVars()["s_cid"];
	var i_cid = getUrlVars()["i_cid"];
	var vid = getUrlVars()["vid"];

	if (!ms) {
	    ms = "owned_site_sg";
	}

	if (!mt) {
	    mt = "product_bdefault";
	}

	var URL = "?ms=" + ms + "&mt=" + mt;

	if (!s_cid && !i_cid) {
	    i_cid = "shopuob_fixed_201807_na";
	    URL += "&i_cid=" + i_cid;
	} else {
	    if (i_cid) {
	        URL += "&i_cid=" + i_cid;
	    }

	    if (s_cid) {
	        URL += "&s_cid=" + s_cid;
	    }
	}

	if (!vid) {
	    vid = "none";
	}

	if (vid) {
	    URL += "&vid=" + vid;
	}

	$(document).ready(function() {
	    var cards_obj = [];
	    var cards_obj = [{
	            el: "card_ladys",
	            pid: "ladys"
	        },
	        {
	            el: "card_one",
	            pid: "001843"
	        },
	        {
	            el: "card_prvi_miles",
	            pid: "prvi"
	        },
	        {
	            el: "card_yolo",
	            pid: "001454"
	        },
	        {
	            el: "card_common",
	            pid: "cc"
	        },
	    ];

	    setTimeout(function() {
	        //Index Page
	        $.each(cards_obj, function(key, value) {
	            if ($('.' + value.el).length > 0) {
	                var card_links = $('.' + value.el).attr('href');
	                $('.' + value.el).attr('href', card_links + URL + "&productid=" + value.pid);
	                if (value.el !== 'card_common') {
	                    var card_details = $('.' + value.el + '_details').attr('href');
	                    $('.' + value.el + '_details').attr('href', card_details + URL + "&productid=" + value.pid);
	                }
	            }
	        });

	        //Other Pages CTA
	        if ($('.flbx-ct').length > 0) {
	            var banner_cta_obj = $('.flbx-ct').children().closest('a');
	            var banner_cta_link = banner_cta_obj.attr('href');
	            banner_cta_obj.attr('href', banner_cta_link + URL + "&productid=cc");
	        }

	        //Menu
	        if ($('.mobile-menu').length > 0) {
	            var menu_cta_obj = $('.mobile-menu li').last().children();
	            var menu_cta_link = menu_cta_obj.attr('href');
	            menu_cta_obj.attr('href', menu_cta_link + URL + "&productid=cc");
	        }

	        if ($('.main-menu').length > 0) {
	            var main_menu_cta_obj = $('.main-menu li').last().children();
	            var main_menu_cta_link = main_menu_cta_obj.attr('href');
	            main_menu_cta_obj.attr('href', main_menu_cta_link + URL + "&productid=cc");
	        }

	    }, 500);
	});